import { Injectable } from '@angular/core';
import {
  AccountTrackingObject,
  IAccountTrackingObjectData,
} from './objects/account-tracking-object.model';

@Injectable()
export class TrackingObjectBuilder {
  buildAccount({
    email,
    accountId,
    i2gUserId,
  }: IAccountTrackingObjectData = {}): AccountTrackingObject {
    const trackingKeys = AccountTrackingObject.KEYS;

    return new AccountTrackingObject({
      [trackingKeys.EMAIL]: email,
      [trackingKeys.ACCOUNT_ID]: accountId,
      [trackingKeys.I2G_USER_ID]: i2gUserId,
    });
  }
}
